module.exports = __webpack_public_path__ + "img/frame (131).d5f09400.jpg";